/*
 * Copyright (C) 2018 envisia GmbH
 * All Rights Reserved.
 */
import {NgModule} from '@angular/core';
import {SharedModule} from '../../../../core/shared.module';
import {FetchBoxComponent} from './fetch-box.component';
import {FetchBoxInnerComponent} from './fetch-box-inner.component';
import {LoadingOrErrorModule} from '../../../../common/loading/loading-or-error.module';
import { FetchBoxPositionComponent } from './fetch-box-position.component';
import {FetchModule} from '../fetch.module';
import {FetchBoxPositionFreezeFormReact} from './fetch-box-position-freeze-form-react.component';
import {FetchBoxConfirmPriceComponent} from './fetch-box-confirm-price.component';
import {FetchBoxHeaderComponent} from './fetch-box-header.component';
import {EvStatusLabelComponent} from '../../../../common/ev-status-label/ev-status-label.component';

@NgModule({
    imports: [
        SharedModule,
        LoadingOrErrorModule,
        FetchModule,
        FetchBoxConfirmPriceComponent,
        FetchBoxHeaderComponent,
        EvStatusLabelComponent,
    ],
    declarations: [
        FetchBoxComponent,
        FetchBoxInnerComponent,
        FetchBoxPositionComponent,
        FetchBoxPositionFreezeFormReact,
    ],
    exports: [
        FetchBoxComponent
    ]
})
export class FetchBoxModule {
}
